import { Position, Transform } from 'types'
import { transformOriginMultiplier } from '../transform-origin'

export function transformPosition(position: Position, transform: Transform): Position {
    const { height, rotation = 0, width, x, y } = position
    const multiplier = transformOriginMultiplier(transform.origin || 'center')
    const scaledHeight = Math.round(height * transform.scaleY)
    const scaledWidth = Math.round(width * transform.scaleX)
    const shiftX = -(scaledWidth - width) * multiplier.x
    const shiftY = -(scaledHeight - height) * multiplier.y

    return {
        height: Math.round(height * transform.scaleY),
        rotation: rotation + transform.rotation,
        width: Math.round(width * transform.scaleX),
        x: x + transform.x + shiftX,
        y: y + transform.y + shiftY,
    }
}
